import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Panel from 'components/Panel/Panel';
import SvgIcon from 'components/SvgIcon/SvgIcon';
import styles from './Expandable.module.scss';

export default class Expandable extends Component {
  static propTypes = {
    children: PropTypes.element,
    expandedStyle: PropTypes.object,
    maxHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    mobileOnly: PropTypes.bool,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    startExpanded: PropTypes.bool,
  };

  static defaultProps = {
    expandedStyle: {},
    maxHeight: '',
    mobileOnly: false,
    startExpanded: false,
    boxshadow: false,
  };

  state = {
    expanded: this.props.startExpanded,
  };

  handleExpanded = () => this.setState({ expanded: !this.state.expanded });

  render() {
    const { expanded } = this.state;
    const { children, expandedStyle, title, maxHeight, mobileOnly } =
      this.props;
    const style = { maxHeight, ...expandedStyle };
    return (
      <Panel className={this.props.boxshadow ? 'box-shadow' : ''}>
        <div
          className={`${styles.titleContainer} ${
            mobileOnly ? styles.xsOnly : ''
          }`}
          onClick={this.handleExpanded}
        >
          <Panel.Header>{title}</Panel.Header>
          <SvgIcon
            className={`${styles.chevron} ${expanded ? styles.up : ''}`}
            icon="chevron-down"
            size="18"
          />
        </div>
        {expanded && <hr style={{ margin: 0 }} />}
        <div
          className={`${styles.content} ${
            expanded ? styles.contentExpanded : ''
          } ${mobileOnly ? styles.xsOnly : ''}`}
          style={expanded ? style : {}}
        >
          {children}
        </div>
      </Panel>
    );
  }
}
